const INITIAL_STATE = {
  toastNotifications: [],
};

const ADD_TOAST = 'reducer/toasts/ADD_TOAST';
const REMOVE_TOAST = 'reducer/toasts/REMOVE_TOAST';

function toastsReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case ADD_TOAST:
      return handleAddToast(state, payload);
    case REMOVE_TOAST:
      return handleRemoveToast(state, payload);
    default:
      return state;
  }
}

function handleAddToast(state, { id, message, type }) {
  return {
    ...state,
    toastNotifications: [{ id, message, type }, ...state.toastNotifications],
  };
}

function handleRemoveToast(state, { id }) {
  return {
    ...state,
    toastNotifications: state.toastNotifications.filter(toast => toast.id !== id),
  };
}

// Action creators

export function addToast(id, message, type) {
  return {
    type: ADD_TOAST,
    payload: {
      id,
      message,
      type,
    },
  };
}

export function removeToast(id) {
  return {
    type: REMOVE_TOAST,
    payload: {
      id,
    },
  };
}

export default toastsReducer;



// WEBPACK FOOTER //
// ./src/reducer/toasts.js